import { Building, BarChart } from 'lucide-vue-next';



export const adminOptions = [
  
  {
    title: 'Usage',
    toolTip: "View User & Tenant Metrics",
    icon: BarChart,
    class: 'large-button',
    href: '/app/administration/tenant-metrics', // Vue route path
  },
  {
    title: 'Tenant',
    toolTip: 'Tenant Administration',
    icon: Building,
    class: 'large-button',
    href: '/app/administration/tenant-management', // Vue route path
  },
];


